import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from '../../../../../../media';

export const categoryCard = css`
	${breakpoints.only.mobile} {
		padding: 0;
		border: none;
		border-radius: 0;
	}
`;

export const imgStyles = css`
	width: calc(100% + 32px);
	min-height: 165px;
	max-height: 165px;
	margin-top: -16px;
	margin-bottom: 8px;
	border-radius: 8px 8px 0 0;
	margin-inline: -16px;
	object-fit: cover;

	${breakpoints.only.mobile} {
		min-width: 146px;
		max-width: 146px;
		min-height: 136px;
		max-height: 136px;
		margin-inline: 0;
		border-radius: 8px;
		margin-block: 0;
	}
`;

export const StyledDiv = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 4px;
`;
